import React from "react";
import { Typography } from "@mui/material";

const TopPages = ({ analyticsData, themeBg }) => {
  // Get the full list of pages
  const allPages = analyticsData?.pages?.top || [];
  
  // Limit to only 8 records for display
  const limitedTopPages = allPages.slice(0, 6) || [];
  
  // Calculate how many additional URLs are not shown
  const hiddenUrlCount = Math.max(0, allPages.length - 6);
  
  // Function to clean URL by removing the domain prefix
  const cleanUrl = (url) => {
    if (!url) return "";
    
    // If it's exactly the homepage URL or homepage with trailing slash, keep it as is
    if (url === "https://www.bapujidental.edu/" || url === "https://www.bapujidental.edu") {
      return url;
    }
    
    // Otherwise remove the domain prefix for all other URLs
    return url.replace(/https?:\/\/www\.bapujidental\.edu(\/|$)/, '/');
  };
  
  return (
    <div
      style={{
        backgroundColor: themeBg || "#047857",
        borderRadius: "12px",
        padding: "20px",
        color: "#FFFFFF",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        variant="h6"
        style={{ fontWeight: "bold", marginBottom: "10px" }}
      >
        Top Screens
      </Typography>
      
      {/* Table layout for better alignment */}
      <table style={{
        width: "100%", 
        borderCollapse: "separate",
        borderSpacing: "0 5px",
        marginTop: "15px"
      }}>
        {/* Table Header */}
        <thead>
          <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.3)" }}>
            <th style={{ 
              textAlign: "left", 
              fontSize: "12px", 
              fontWeight: "bold",
              paddingBottom: "8px", 
              width: "75%" 
            }}>
              Top URLs
            </th>
            <th style={{ 
              textAlign: "right", 
              fontSize: "12px",
              fontWeight: "bold", 
              paddingBottom: "8px",
              width: "25%"
            }}>
              Sessions
            </th>
          </tr>
        </thead>
        
        {/* Table Body */}
        <tbody>
          {limitedTopPages.length > 0 ? (
            limitedTopPages.map((page, index) => (
              <tr key={index} style={{ 
                backgroundColor: index % 2 === 0 ? "rgba(255,255,255,0.05)" : "transparent",
              }}>
                <td style={{ 
                  padding: "6px 8px 6px 0",
                  fontFamily: "'Roboto Mono', monospace",
                  fontSize: "12px",
                  wordBreak: "break-all",
                  maxWidth: "0", // Forces text ellipsis to work with flex
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}>
                  {cleanUrl(page.url)}
                </td>
                <td style={{ 
                  padding: "6px 0",
                  textAlign: "right",
                  fontSize: "12px",
                  fontWeight: "bold"
                }}>
                  {page.sessions}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} style={{ textAlign: "center", padding: "10px 0" }}>
                No page data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      
      {/* Add note about additional URLs */}
      {hiddenUrlCount > 0 && (
        <div style={{ 
          marginTop: "12px", 
          textAlign: "center", 
          fontSize: "12px", 
          color: "rgba(255,255,255,0.7)",
          fontStyle: "italic",
          borderTop: "1px dashed rgba(255,255,255,0.3)",
          paddingTop: "8px"
        }}>
          + {hiddenUrlCount} more URL{hiddenUrlCount !== 1 ? 's' : ''} not shown
        </div>
      )}
    </div>
  );
};

export default TopPages;
